import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { Order } from 'models/order';
import { OrderItemEvent, OrderItemEventType } from 'models/order-item-events';
import { AccountArrowRight } from 'mdi-material-ui';

type ExternalLabUsersIconButtonProps = {
    order: Order;
    onOrderItemEvent?: (event: OrderItemEvent) => void;
};
const ExternalLabUsersIconButton: FC<ExternalLabUsersIconButtonProps> = ({
    order,
    onOrderItemEvent,
}: ExternalLabUsersIconButtonProps) => {
    const { t: translate } = useTranslation(['orders']);

    return (
        <Tooltip title={<span>{translate('orders:MANAGE_EXTERNAL_USERS')}</span>}>
            <IconButton
                size="small"
                onClick={(e) => {
                    e.stopPropagation();
                    if (onOrderItemEvent) {
                        onOrderItemEvent({
                            order: order,
                            eventType: OrderItemEventType.MANAGE_EXTERNAL_LAB_USERS,
                        });
                    }
                }}
            >
                {order.linkedExtTechs?.length > 0 ? (
                    <AccountArrowRight />
                ) : (
                    <AccountArrowRight sx={{ color: '#f2f2f2' }} />
                )}
            </IconButton>
        </Tooltip>
    );
};

export default ExternalLabUsersIconButton;
